var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('pre',{directives:[{name:"highlightjs",rawName:"v-highlightjs",value:(_vm.parsed),expression:"parsed"}]},[_c('code',{staticClass:"json"})])])}
var staticRenderFns = []

export { render, staticRenderFns }